import ArticlePageHeroSection from "./_components/article-page-hero-section";

export default ArticlePageHeroSection;
